import * as React from "react";
import { AskAboutQuery_RichAnswer } from "../../../../../graphql-types";
import SocialShare from "../../../ui-library/social-share/social-share";
import Feedback from "../../../feedback/feedback";
import CovidTimeline from "../intent-specific-answers/covid-19-timeline/covid-timeline";
import DailyCaseByGlobal from "../intent-specific-answers/daily-case-by-country/daily-cases-global/daily-case-global";
import Resources from "../intent-specific-answers/resources/resources";
import CountriesControlSnapshots from "../intent-specific-answers/countries-control-snapshots/countries-control-snapshots";
import CountriesControlSnapshotsWithTest from "../intent-specific-answers/countries-control-snapshots/countries-control-snapshots-with-test";
import CovidCategories from "../../covid-categories/covid-categories";
import Container from "../../../ui-library/container/container";
import { SPECIAL_INTENTS } from "../../../../constants/special-intents";
import CountriesInfectionRates from "../intent-specific-answers/countries-control-snapshots/countries-infection-rates";
import { Topic } from "../../../../types/topics";
import RichAnswers from "../../../common-page-sections/rich-answers/rich-answers";
import USStatesControlSnapshots from "../intent-specific-answers/countries-control-snapshots/us-states-control-snapshots";
import USStatesInfectionRates from "../intent-specific-answers/countries-control-snapshots/us-states-infection-rates";
import HowCanWeWin from "../intent-specific-answers/how-can-we-win/how-can-we-win";
import { getCOVIDIntentUrl } from "../../../../utils/question-url";
import CountrySituationTable from "../intent-specific-answers/country-situation-table/country-situation-table";
import MaskStopTransimissionInfographic from "../intent-specific-answers/mask-stop-transmission-infographic/mask-stop-transmission-infographic";
import MaskCategoryLinks from "../intent-specific-answers/mask-stop-transmission-infographic/mask-category-links";
import PittaMaskAds from "../intent-specific-answers/amazon-affiliate/pitta-masks";

interface CovidAnswersProps {
  alias: string;
  intentName: string;
  displayName: string;
  messages?: string[] | null;
  richAnswers: AskAboutQuery_RichAnswer[];
}

const CovidAnswers: React.FC<CovidAnswersProps> = ({
  alias,
  intentName,
  displayName,
  messages,
  richAnswers,
}) => {
  return (
    <>
      {intentName === SPECIAL_INTENTS.HowToWin.name && <HowCanWeWin />}

      {intentName === SPECIAL_INTENTS.GlobalSituation.name && (
        <DailyCaseByGlobal intentName={SPECIAL_INTENTS.GlobalSituation.name} />
      )}

      {intentName === SPECIAL_INTENTS.TimeLine.name && <CovidTimeline />}

      {intentName === SPECIAL_INTENTS.Resources.name && (
        <Container>
          <Resources />
        </Container>
      )}
      {intentName === SPECIAL_INTENTS.SituationSnapshot.name && (
        <CountriesControlSnapshots />
      )}
      {intentName === SPECIAL_INTENTS.USSituationSnapshot.name && (
        <USStatesControlSnapshots />
      )}
      {intentName === SPECIAL_INTENTS.SituationSnapshotWithTest.name && (
        <CountriesControlSnapshotsWithTest />
      )}
      {intentName === SPECIAL_INTENTS.InfectionRate.name && (
        <CountriesInfectionRates />
      )}
      {intentName === SPECIAL_INTENTS.USInfectionRate.name && (
        <USStatesInfectionRates />
      )}
      {intentName === SPECIAL_INTENTS.Topics.name && (
        <Container>
          <CovidCategories />
        </Container>
      )}
      {intentName === SPECIAL_INTENTS.CountrySituationList.name && (
        <CountrySituationTable />
      )}

      {intentName === SPECIAL_INTENTS.WhyMask.name && (
        <MaskStopTransimissionInfographic />
      )}

      <RichAnswers displayName={displayName} richAnswers={richAnswers} />

      {intentName === SPECIAL_INTENTS.PittaMask.name && <PittaMaskAds />}

      <Feedback intentName={intentName} topic={Topic.COVID19} />

      {intentName === SPECIAL_INTENTS.WhyMask.name && <MaskCategoryLinks />}

      <SocialShare
        title={displayName}
        description={messages && messages.length > 0 ? messages[0] : ""}
        url={getCOVIDIntentUrl(alias)}
      />
    </>
  );
};

export default CovidAnswers;
